// extracted by mini-css-extract-plugin
module.exports = {"form":"sendMsg_form__10qPu"};